/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('global/ProductHelper',[
    'lodash',
    './Logger'
], function (_, Logger) {
    'use strict';

    /**
     * Function copies productSFSNumber value from custom fields dictionary to product.productSFSNumber for easier access in handlebar templates
     * @param {any} order
     */
    function setProductSFSNumber(item) {
        if (item.product.customFields && item.product.customFields["productSFSNumber"]) {
            var productSFSNumber = item.product.customFields["productSFSNumber"];
            if (productSFSNumber.length > 0) {
                item.productSFSNumber = productSFSNumber[0].value;
            }
        }
    }

    var ProductHelper = {
        setProductSFSNumber: setProductSFSNumber
    };

    Logger.debug('ProductHelper.js Loaded:', ProductHelper);

    return ProductHelper;
});
